import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '9.8301 4.905'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M17.8403 0.830078C17.8403 0.830078 14.0103 2.04008 9.84033 2.04008C5.67033 2.04008 1.84033 0.830078 1.84033 0.830078C4.78033 6.85008 7.96033 7.98008 9.84033 7.98008C11.7203 7.98008 14.9003 6.85008 17.8403 0.830078Z"
          fill="white"
        />
        <path
          d="M9.83011 9.81C3.93011 9.81 0.870117 0 0.870117 0C0.870117 0 5.79011 1.53 9.83011 1.53C13.8701 1.53 18.7901 0 18.7901 0C18.7901 0 15.7301 9.81 9.83011 9.81ZM2.79013 1.61C5.55013 6.69 8.35013 7.48 9.82013 7.48C11.3001 7.48 14.1101 6.69 16.8601 1.61C15.4001 1.98 12.7101 2.53 9.82013 2.53C6.93013 2.53 4.25013 1.98 2.79013 1.61Z"
          fill={outline}
        />
      </g>
    </g>
  )
}
